import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'element-plus/dist/index.css'
// import './index.scss'
import ElementPlus from 'element-plus'


import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './vuex/index'



createApp(App).use(router).use(store).use(VueAxios, axios).use(ElementPlus).mount('#app')
